export const FILTERS = [
  { slug: "todos", label: "Todos" },
  { slug: "racoes", label: "Rações" },
  { slug: "pet", label: "Pet" },
  { slug: "campo", label: "Campo" },
  { slug: "jardim", label: "Jardim" },
];

export const PRODUCTS = [
  {
    id: "racao-caes-premium",
    name: "Ração Premium Cães Adultos",
    category: "racoes",
    categoryLabel: "Rações",
    price: "R$ 89,90",
    unit: "saco 15kg",
    badge: "Mais Vendido",
    image:
      "https://images.unsplash.com/photo-1714068691210-073dc52c6c1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHxfHxkb2clMjBmb29kJTIwa2liYmxlJTIwYm93bCUyMHJ1c3RpY3xlbnwwfHx8fDE3OTEyMjMzMTN8MA&ixlib=rb-4.1.0&q=85",
    short: "Nutrição completa com frango, arroz e ômega 3 para cães adultos de todos os portes.",
    specs: ["Proteína bruta 26%", "Ômega 3 e 6 para pelagem", "Sem corantes artificiais", "Saco de 15kg"],
  },
  {
    id: "racao-gatos-castrados",
    name: "Ração Gatos Castrados",
    category: "racoes",
    categoryLabel: "Rações",
    price: "R$ 74,90",
    unit: "saco 10kg",
    image:
      "https://images.unsplash.com/photo-1616668983570-a971956d8928?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTJ8MHwxfHNlYXJjaHxffGNhdCUyMGZvb2QlMjBib3dsJTIwa2liYmxlfGVufDB8fHx8MTc5MTIyMzMxM3ww&ixlib=rb-4.1.0&q=85",
    short: "Fórmula com controle de pH urinário e baixo teor de gordura para gatos castrados.",
    specs: ["Controle de peso", "Saúde urinária", "Rico em taurina", "Saco de 10kg"],
  },
  {
    id: "petiscos-naturais",
    name: "Petiscos & Ossinhos Naturais",
    category: "pet",
    categoryLabel: "Pet",
    price: "R$ 19,90",
    unit: "pacote 500g",
    image:
      "https://images.unsplash.com/photo-1592468257342-8375cb556a69?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxkb2clMjB0cmVhdHMlMjBwZXQlMjBzbmFja3N8ZW58MHx8fHwxNzkxMjIzMzEzfDA&ixlib=rb-4.1.0&q=85",
    short: "Petiscos assados e ossinhos para recompensa, adestramento e saúde bucal.",
    specs: ["100% natural", "Auxilia na limpeza dos dentes", "Pacote de 500g"],
  },
  {
    id: "coleira-couro",
    name: "Coleira de Couro Artesanal",
    category: "pet",
    categoryLabel: "Pet",
    price: "R$ 49,90",
    unit: "tamanhos P/M/G",
    image:
      "https://images.unsplash.com/photo-1708062270853-ee7c66b69f07?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHxffGxlYXRoZXIlMjBkb2clMjBjb2xsYXIlMjBsZWFzaCUyMHJ1c3RpY3xlbnwwfHx8fDE3OTEyMjMzMTN8MA&ixlib=rb-4.1.0&q=85",
    short: "Couro legítimo costurado à mão, com fivela reforçada e acabamento rústico.",
    specs: ["Couro legítimo", "Fivela em metal nobre", "Tamanhos P, M e G"],
  },
  {
    id: "sal-mineral-bovino",
    name: "Sal Mineral Bovino",
    category: "campo",
    categoryLabel: "Campo",
    price: "R$ 62,00",
    unit: "saco 30kg",
    badge: "Mais Vendido",
    image:
      "https://images.unsplash.com/photo-1789296903495-8a264c483aa3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHxffGNhdHRsZSUyMGZhcm0lMjBsaXZlc3RvY2slMjBmZWVkZXIlMjBydXJhbHxlbnwwfHx8fDE3OTEyMjMzMTN8MA&ixlib=rb-4.1.0&q=85",
    short: "Suplementação mineral completa para ganho de peso e saúde do rebanho.",
    specs: ["Macro e microminerais", "Alta palatabilidade", "Saco de 30kg", "Uso em cocho"],
  },
  {
    id: "kit-selaria",
    name: "Kit Selaria & Cuidados do Cavalo",
    category: "campo",
    categoryLabel: "Campo",
    price: "Consulte",
    unit: "peças sob medida",
    image:
      "https://images.unsplash.com/photo-1773353328317-7fe3526357b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxsZWF0aGVyJTIwc2FkZGxlJTIwaG9yc2UlMjBnZWFyJTIwcnVyYWx8ZW58MHx8fHwxNzkxMjIzMzEzfDA&ixlib=rb-4.1.0&q=85",
    short: "Selas, rédeas, bridões e itens de couro para o trabalho e o lazer no campo.",
    specs: ["Couro curtido artesanal", "Peças sob encomenda", "Manutenção e ajuste na loja"],
  },
  {
    id: "sementes-horta",
    name: "Sementes Selecionadas de Horta",
    category: "jardim",
    categoryLabel: "Jardim",
    price: "R$ 12,90",
    unit: "pacote 50g",
    image:
      "https://images.unsplash.com/photo-1622383563227-04401ab4e5ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHxzZWVkcyUyMHBsYW50aW5nJTIwc29pbCUyMGdhcmRlbmluZyUyMHJ1c3RpY3xlbnwwfHx8fDE3OTEyMjMzMTN8MA&ixlib=rb-4.1.0&q=85",
    short: "Sementes de alta germinação para horta caseira: alface, tomate, couve e ervas.",
    specs: ["Alta taxa de germinação", "Variedades regionais", "Pacote de 50g"],
  },
  {
    id: "kit-ferramentas-jardim",
    name: "Kit Ferramentas de Jardim",
    category: "jardim",
    categoryLabel: "Jardim",
    price: "R$ 59,90",
    unit: "kit com 3 peças",
    image:
      "https://images.unsplash.com/photo-1598851418241-f52c34b6e4c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxnYXJkZW5pbmclMjB0b29scyUyMHBydW5lcnMlMjB3b29kZW4lMjBoYW5kbGV8ZW58MHx8fHwxNzkxMjIzMzEzfDA&ixlib=rb-4.1.0&q=85",
    short: "Tesoura de poda, pá e ancinho com cabo de madeira envernizada e aço temperado.",
    specs: ["Aço temperado", "Cabo de madeira envernizada", "Kit com 3 peças"],
  },
];
